import React, { SyntheticEvent } from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import PopupContainer from '../../../common/components/PopupContainer';
import { MusicEntity } from '../../types/MusicEntityTypes';

export default function MusicAlbumEditForm2AddPopupView({
  musics,
  isMusicSelected,
  setMusicSelected,
  isLoadingMore,
  onCancel,
  onReadMore,
  onSubmit,
} : {
  musics: MusicEntity[],
  isMusicSelected: (music: MusicEntity) => boolean,
  setMusicSelected: (music: MusicEntity, selected: boolean) => void,
  isLoadingMore: boolean,
  onCancel: () => void,
  onReadMore: () => void,
  onSubmit: () => void,
}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <PopupContainer title="曲を追加する" onClose={() => onCancel()}>
      <p>すでにアップロードした曲の中から、このリリースに収録する曲をピックアップしよう！</p>
      <ul>
        <li className="bt">
          <CustomButton type="default" onClick={() => onSubmit()}>
            リリースに追加する
          </CustomButton>
        </li>
      </ul>
      <div className="popup_scroll_box">
        <form>
          <div className="form__body">
            <dl>
              {musics.map((music) => (
                <dd key={music.id}>
                  <CustomCheckbox
                    checked={isMusicSelected(music)}
                    setChecked={(checked) => setMusicSelected(music, checked)}
                  >
                    {music.title}
                  </CustomCheckbox>
                </dd>
              ))}
            </dl>
          </div>
        </form>
        {isLoadingMore && (
          <>
            読み込み中...
          </>
        )}
        {!isLoadingMore && (
          <>
            { /* eslint-disable-next-line max-len */ }
            { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */ }
            <a onClick={(e) => { cancelEvent(e); onReadMore(); }}>さらに読み込む</a>
          </>
        )}
      </div>
    </PopupContainer>
  );
}
